import axiosIns from '@axios'

/**
 * PROP-468: РЕЖИМ РАБОТЫ АГЕНТА в интерфейсе — «Работа с данными» и «Конструктор».
 *
 * ЗАЧЕМ. В режиме «Работа с данными» (он по умолчанию) агенту закрыты операции, меняющие
 * структуру домена. Это не отсечение доступа, а защита от СЛУЧАЙНОГО изменения структуры: агент
 * может не так понять задание — тогда и срабатывает защита.
 *
 * ПОЧЕМУ ПЕРЕКЛЮЧАТЕЛЬ ЗДЕСЬ, А НЕ ИНСТРУМЕНТ У АГЕНТА. Решение владельца: режим переключает
 * ЧЕЛОВЕК. Инструмент смены режима отдал бы выключатель защиты тому, от чьей ошибки она ставится:
 * достаточно попросить в тексте вопроса — и модель выйдет из режима сама, совершенно искренне.
 *
 * ⚠️ РЕЖИМ — СВОЙСТВО ПОЛЬЗОВАТЕЛЯ В ДОМЕНЕ, А НЕ ВКЛАДКИ. Переключив его здесь, человек меняет
 * режим и своему Claude Code, и Cursor — всему, что ходит в этот домен под его учёткой. Об этом
 * надо СКАЗАТЬ рядом с переключателем, а не оставлять догадываться.
 */

export const DATA = 'data'
export const BUILDER = 'builder'

export const MODE_OPTIONS = [
  { value: DATA, text: 'Работа с данными' },
  { value: BUILDER, text: 'Конструктор' },
]

/** Подпись режима человеку. Незнакомое значение — это «данные»: так же считает и сервер. */
export function modeLabel(mode) {
  const found = MODE_OPTIONS.find(o => o.value === mode)
  return found ? found.text : MODE_OPTIONS[0].text
}

export function modeHint(mode) {
  return mode === BUILDER
    ? 'Агенту разрешено менять структуру домена: объекты, атрибуты, сборки, интерфейс, права.'
    : 'Агент не может менять структуру домена — только читать её и работать с данными. '
      + 'Защита от случайной правки, если задание понято не так.'
}

/**
 * Текущий режим по ответу `/api/whoami`.
 *
 * ⚠️ ПОЛЯ МОЖЕТ НЕ БЫТЬ, и это не ошибка: домен, раскатанный до `PROP-464`, механизма не имеет —
 * там режим НЕ ПРИМЕНЯЕТСЯ, и показывать переключатель, который ничего не меняет, нельзя.
 * Возвращаем `null` — «режима здесь нет», и это отличается от «выбран режим данных».
 */
export function modeFromWhoami(data) {
  if (!data || typeof data !== 'object') return null
  const raw = data.agentmode
  if (typeof raw !== 'string' || !raw) return null
  return raw === BUILDER ? BUILDER : DATA
}

/**
 * Сохранить свой режим. Пишется РОВНО своя строка: пользователь берётся из сессии, тело несёт
 * только сам режим (и, при работе в чужом домене, его имя).
 */
export async function saveAgentMode(mode, domainsid) {
  const body = { mode }
  if (domainsid) body.domainsid = domainsid
  const res = await axiosIns.post('/api/agentmode', body)
  const data = (res && res.data) || {}
  if (data.error) throw new Error(data.error)
  return data.agentmode || mode
}

/** Прочитать режим отдельным запросом — когда `whoami` уже прошёл мимо. */
export async function loadAgentMode() {
  const res = await axiosIns.post('/api/whoami', {})
  return modeFromWhoami(res && res.data)
}
